export default __webpack_public_path__ + "static/media/guy.c85a152f.png";